import React from "react";
import { useListDataImports } from "@workspace/api-client-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";

export function DataImportsList() {
  const { data: importsPage, isLoading, error } = useListDataImports();
  const imports = importsPage?.items ?? [];

  if (isLoading) return <div className="p-6 animate-pulse"><div className="h-8 bg-gray-200 w-1/4 rounded mb-6"></div><div className="h-64 bg-gray-200 rounded"></div></div>;
  if (error) return <div className="p-6 text-red-500">Failed to load data imports.</div>;

  return (
    <Card className="border-0 shadow-sm">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-lg text-[#0B132B]">Data Imports</CardTitle>
        <Button className="bg-[#E6007E] hover:bg-[#c4006b] text-white"><Upload className="w-4 h-4 mr-2"/> New Import</Button>
      </CardHeader>
      <CardContent className="p-0">
        <Table>
          <TableHeader className="bg-gray-50">
            <TableRow>
              <TableHead>File Name</TableHead>
              <TableHead>Source</TableHead>
              <TableHead>Created</TableHead>
              <TableHead className="text-right">Processed / Total</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {imports.map((item) => (
              <TableRow key={item.id}>
                <TableCell className="font-medium">{item.fileName}</TableCell>
                <TableCell>{item.source}</TableCell>
                <TableCell>{item.createdAt ? new Date(item.createdAt).toLocaleString() : '-'}</TableCell>
                <TableCell className="text-right">{item.rowsProcessed || 0} / {item.rowsTotal || 0}</TableCell>
                <TableCell><StatusBadge status={item.status} /></TableCell>
              </TableRow>
            ))}
            {imports.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} className="text-center p-8 text-gray-500">No data imports found.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
